import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Youtube',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M23.5 6.19a3.033 3.033 0 0 0-2.12-2.14c-1.87-.5-9.38-.5-9.38-.5s-7.51 0-9.38.5C1.59 4.33.78 5.15.5 6.19 0 8.07 0 12 0 12s0 3.93.5 5.81a3.033 3.033 0 0 0 2.12 2.14c1.87.5 9.38.5 9.38.5s7.51 0 9.38-.5c1.03-.28 1.85-1.1 2.12-2.14.5-1.88.5-5.81.5-5.81s0-3.93-.5-5.81zM9.55 15.57V8.43L15.82 12l-6.27 3.57z" }
      })]
    );
  }
};